import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { IProjectOperatingCompany } from '../../interfaces/IProjectOperatingCompany';

@Component({
  selector: 'eic-operating-companies',
  templateUrl: './operating-companies.component.html',
  styleUrl: './operating-companies.component.scss'
})
export class OperatingCompaniesComponent {
  @Input() operatingCompanies$: Observable<IProjectOperatingCompany[]>;
}
